import React from 'react'

const Edit = ({about}) => {
  return (
    <div className="italic my-4">{about}</div>
  )
}

export default Edit